import { useSetReelsDataState, useUpsertReels } from '@/store/reels/reels.hook';
import { ERROR_DATA_STATE, LOADING_DATA_STATE } from '@/types/data.type';
import { buildDataStateMap } from '@/util/dataStateMap.util';
import { fetchReelsBatch } from '@/util/fetchReels.util';
import { logDebug } from '@/util/log.util';

import { useInteractiveCallback } from './useInteractiveCallback';

export function useRefreshReels() {
    const upsertReels = useUpsertReels();
    const setReelsDataState = useSetReelsDataState();

    return useInteractiveCallback(async (codes: string[]) => {
        if (!codes.length) {
            return;
        }

        setReelsDataState(buildDataStateMap(codes, LOADING_DATA_STATE));

        try {
            const reels = await fetchReelsBatch(codes);

            upsertReels(reels);
        } catch (ex) {
            logDebug('[useRefreshReels] Error refreshing reels', ex);

            setReelsDataState(buildDataStateMap(codes, ERROR_DATA_STATE));
        }
    });
}
